<template>
	<v-card flat class="grey lighten-5">
		<v-card-title>{{ $t('ShoppingCart.Overzicht') }}</v-card-title>
		<v-card-subtitle>{{ $t('ShoppingCart.Je_gaat_deze_producten_bestellen') }}</v-card-subtitle>
		<v-card-text>
			<v-list class="transparent" dense>
				<!-- PRODUCTS-->
				<template v-for="(item, index) in cartItems">
					<v-list-item :key="item.cartItemId">
						
						<v-list-item-avatar tile>
							<span class="font-weight-medium">{{ item.quantity }} x</span>
						</v-list-item-avatar>
						<v-list-item-content>
							<v-list-item-title>{{ item.productName }}</v-list-item-title>
							<v-list-item-subtitle>{{ item.productCode }}</v-list-item-subtitle>
							<div class="text-caption">
								<span>{{ cart.currency }}</span>
								&nbsp;
								<span>{{ $n(item.unitPriceExclVat, "decimal") }}</span>
								<span v-if="item.discountPerc" class="ml-2 error--text">
									&nbsp; {{ $n(item.discountPerc * -0.01, "percent") }}
								</span>
								
							</div>
						</v-list-item-content>
						<v-list-item-action class="ml-1">
							<v-btn plain icon @click="deleteCartItem(item)">
								<v-icon small>mdi-delete</v-icon>
							</v-btn>
						</v-list-item-action>
					</v-list-item>					
				</template>
				<v-divider class="my-2" />
				<!-- TOTALS-->
				<v-list-item dense>
					<v-list-item-content>
						<v-list-item-title>{{ $t("ShoppingCart.Netto") }}</v-list-item-title>
					</v-list-item-content>
					<v-list-item-action>
						<span>{{ $n(cart.netAmount, "decimal") }}</span>
					</v-list-item-action>
				</v-list-item>
				<v-list-item dense>
					<v-list-item-content>
						<v-list-item-title>{{ $t("ShoppingCart.BTW") }}</v-list-item-title>
						
					</v-list-item-content>
					<v-list-item-action>
						<span>{{ $n(cart.vatAmount, "decimal") }}</span>
					</v-list-item-action>
				</v-list-item>
				<v-list-item dense>
					<v-list-item-content>
						<v-list-item-title>{{ $t("ShoppingCart.Totaal") }}</v-list-item-title>
					</v-list-item-content>
					<v-list-item-action>
						<span class="font-weight-bold">{{ cart.currency }} &nbsp; {{ $n(cart.totalAmount, "decimal") }}</span>
					</v-list-item-action>
				</v-list-item>
			</v-list>
		</v-card-text>
	</v-card>		
</template>

<script>
import { mapGetters } from "vuex";
export default {
	name: "OrderSummary",
	data() {
		return {
			loading: false,
		};
	},
	computed: {
		...mapGetters({
			cart: "shoppingCart/cart",
			cartItems: "shoppingCart/cartItems",
		}),
	},
	methods: {
		deleteCartItem(pCartItem) {
			this.$store.dispatch("shoppingCart/deleteCartItem", pCartItem);
		},
	},
};
</script>



